import {
  FETCH_BY_ID_FLOOR_ERROR,
  FETCH_BY_ID_FLOOR_LOADING,
  FETCH_BY_ID_FLOOR_SUCCESS,
  FETCH_FLOOR_FAILURE,
  FETCH_FLOOR_LOADING,
  FETCH_FLOOR_SUCCESS,
  FETCH_BUILDING_ERROR,
  FETCH_BUILDING_LOADING,
  FETCH_BUILDING_SUCCESS,
  FETCH_BUILDING_BY_ID_LOADING,
  FETCH_BUILDING_BY_ID_SUCCESS,
  FETCH_BUILDING_BY_ID_ERROR,
  UPDATE_BUILDING_LOADING,
  UPDATE_BUILDING_SUCCESS,
  UPDATE_BUILDING_ERROR
} from '../Types/floorTypes';
import api from '../config/api';

const API_WP = process.env.REACT_APP_API_URL;
export const getFloors = () => {
  return dispatch => {
    dispatch({
      type: FETCH_FLOOR_LOADING
    });
    api
      .get(`${API_WP}floor/`)
      .then(response => {
        const { data } = response.data;
        dispatch({
          type: FETCH_FLOOR_SUCCESS,
          payload: data?.sort((a, b) => a.floor_num - b.floor_num)
        });
      })
      .catch(error => {
        const errorMsg = error.message;
        dispatch({
          type: FETCH_FLOOR_FAILURE,
          payload: errorMsg
        });
      });
  };
};

export const getFloorByID = id => {
  return dispatch => {
    dispatch({
      type: FETCH_BY_ID_FLOOR_LOADING
    });
    api
      .get(`${API_WP}floor/search/${id}`)
      .then(response => {
        const { data } = response.data;
        dispatch({
          type: FETCH_BY_ID_FLOOR_SUCCESS,
          payload: data
        });
      })
      .catch(error => {
        const errorMsg = error.message;
        dispatch({
          type: FETCH_BY_ID_FLOOR_ERROR,
          payload: errorMsg
        });
      });
  };
};

export const getFloorByNum = num => {
  return dispatch => {
    dispatch({
      type: FETCH_BY_ID_FLOOR_LOADING
    });
    api
      .get(`${API_WP}floor/getFloorByNum/${num}`)
      .then(response => {
        const { data } = response.data;
        dispatch({
          type: FETCH_BY_ID_FLOOR_SUCCESS,
          payload: data
        });
      })
      .catch(error => {
        const errorMsg = error.message;
        dispatch({
          type: FETCH_BY_ID_FLOOR_ERROR,
          payload: errorMsg
        });
      });
  };
};

export const getFloorsByBuilding = building => {
  return dispatch => {
    dispatch({
      type: FETCH_FLOOR_LOADING
    });
    api
      .get(`${API_WP}floor/getFloorsByBuilding/${building}`)
      .then(response => {
        const { data } = response.data;
        dispatch({
          type: FETCH_FLOOR_SUCCESS,
          payload: data?.sort((a, b) => a.floor_num - b.floor_num)
        });
      })
      .catch(error => {
        const errorMsg = error.message;
        dispatch({
          type: FETCH_FLOOR_FAILURE,
          payload: errorMsg
        });
      });
  };
};

export const getBuildings = () => {
  return dispatch => {
    dispatch({
      type: FETCH_BUILDING_LOADING
    });
    api
      .get(`${API_WP}building/`)
      .then(response => {
        const { data } = response.data;
        dispatch({
          type: FETCH_BUILDING_SUCCESS,
          payload: data
        });
      })
      .catch(error => {
        const errorMsg = error.message;
        dispatch({
          type: FETCH_BUILDING_ERROR,
          payload: errorMsg
        });
      });
  };
};
export const getBuildingById = (id: string) => {
  return dispatch => {
    dispatch({
      type: FETCH_BUILDING_BY_ID_LOADING
    });
    api
      .get(`${API_WP}building/searchbuilding/${id}`)
      .then(response => {
        const { data } = response.data;
        dispatch({
          type: FETCH_BUILDING_BY_ID_SUCCESS,
          payload: data
        });
      })
      .catch(error => {
        const errorMsg = error.message;
        dispatch({
          type: FETCH_BUILDING_BY_ID_ERROR,
          payload: errorMsg
        });
      });
  };
};

export const updateBuilding = (id, data) => {
  return dispatch => {
    dispatch({
      type: UPDATE_BUILDING_LOADING
    });
    api
      .put(`${API_WP}building/updatebuilding/${id}`, data)
      .then(response => {
        const { data } = response.data;
        dispatch({
          type: UPDATE_BUILDING_SUCCESS,
          payload: data
        });
      })
      .catch(error => {
        const errorMsg = error.message;
        dispatch({
          type: UPDATE_BUILDING_ERROR,
          payload: errorMsg
        });
      });
  };
};
